<div class="space-y-4">
  @if (loadError) {
    <div class="rounded-md bg-error-50 p-3 text-sm text-error-700">{{ loadError }}</div>
  }

  @if (scheduledEmails.length > 0) {
    <div class="overflow-hidden rounded-xl border border-gray-200 bg-white dark:border-gray-800 dark:bg-white/[0.03]">
      <table class="min-w-full">
        <thead class="border-t border-gray-100 dark:border-gray-800">
        <tr>
          <th class="border-r border-gray-200 px-4 py-3 text-left dark:border-gray-800">
            <p class="text-theme-xs font-medium text-gray-700 dark:text-gray-400">Email</p>
          </th>
          <th class="w-[22%] border-r border-gray-200 px-4 py-3 text-left dark:border-gray-800">
            <p class="text-theme-xs font-medium text-gray-700 dark:text-gray-400">Sends</p>
          </th>
          <th class="w-[16%] border-r border-gray-200 px-4 py-3 text-left dark:border-gray-800">
            <p class="text-theme-xs font-medium text-gray-700 dark:text-gray-400">Status</p>
          </th>
          <th class="w-[30%] px-4 py-3 text-left">
            <p class="text-theme-xs font-medium text-gray-700 dark:text-gray-400">Why it was stopped</p>
          </th>
        </tr>
        </thead>
        <tbody>
          @for (scheduledEmail of scheduledEmails; track scheduledEmail.id) {
            <tr
              data-testid="contact-scheduled-email-row"
              class="h-12 odd:bg-gray-50 even:bg-white hover:bg-gray-100 dark:odd:bg-gray-800 dark:even:bg-gray-700 dark:hover:bg-gray-600">
              <td class="border-r border-gray-100 px-4 py-3 dark:border-gray-800">
                <p class="text-theme-sm text-gray-700 dark:text-gray-400">{{ scheduledEmail.template_name }}</p>
              </td>
              <td class="border-r border-gray-100 px-4 py-3 dark:border-gray-800">
                <p class="text-theme-sm text-gray-700 dark:text-gray-400">
                  {{ scheduledEmail.scheduled_for | date: 'dd/MM/yyyy HH:mm' }}
                </p>
              </td>
              <td class="border-r border-gray-100 px-4 py-3 dark:border-gray-800">
                <span
                  class="inline-flex items-center rounded-full px-3 py-1 text-xs font-medium"
                  [ngClass]="statusClasses(scheduledEmail)">
                  {{ scheduledEmail.status_label }}
                </span>
              </td>
              <td class="px-4 py-3">
                <p class="text-theme-sm text-gray-700 dark:text-gray-400">
                  {{ scheduledEmail.cancelled_reason_label || '—' }}
                </p>
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  } @else if (!loading && !loadError) {
    <p class="text-gray-500 dark:text-gray-400">No emails are queued for this contact.</p>
  }

  @if (loading) {
    <div class="text-sm text-gray-500 dark:text-gray-400">Loading queued emails…</div>
  }

  <p class="text-xs text-gray-500 dark:text-gray-400">
    This list is read-only. Emails are queued and stopped by the platform, not from here.
  </p>
</div>
